// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__i9Zl6","fadeOut":"Loader_fadeOut__hr_NJ"};